import {BaseModule} from "../types/modules";
import {ActionEnum} from "../types/enums";
import {HelperService} from "../service/helper.service";

export default abstract class FilterStore {
    //corresponding module name, mapped with BO entity name
    public _items: BaseModule[] = [];

    //total count of rows from server
    public _total: number = 0;

    //table loading data
    public _loading: boolean = false;

    //corresponding module name, mapped with BO entity name
    public abstract readonly _module: string;

    //currently active table headers
    //NB: do not add actions into this array, it will be added automatically
    public abstract readonly _headers: string[];

    //available table row actions
    public readonly _actions: ActionEnum[] = [];

    //filter table property routes
    public readonly _propertyRoutes: { property: string, action: string }[] = [];

    //current active page number
    public _current: number = 1;

    //current active page size
    public _pageSize: number = 50;

    //currently active table order column name
    public _orderFieldName?: string;

    //currently active table order column direction
    public _orderDirection?: string;

    public _searchFields: Array<any> = [];

    set pageSize(value: number) {
        this._pageSize = value;
    }
    set current(value: number) {
        this._current = value;
    }

    get current() {
        return this._current;
    }

    get pageSize() {
        return this._pageSize;
    }

    get orderFieldName() {
        return this._orderFieldName;
    }

    set orderFieldName(orderFieldName) {
        this._orderFieldName = orderFieldName;
    }

    get orderDirection() {
        return this._orderDirection;
    }

    set orderDirection(orderDirection) {
        this._orderDirection = orderDirection;
    }

    get headers() {
        return this._headers;
    }

    get actions() {
        return this._actions;
    }

    get module() {
        return this._module;
    }

    set items(items: BaseModule[]) {
        this._items = items;
    }

    get items() {
        return this._items;
    }

    get propertyRoutes() {
        return this._propertyRoutes;
    }

    get total(): number {
        return this._total;
    }

    set total(value: number) {
        this._total = value;
    }

    get loading() {
        return this._loading;
    }

    set loading(value) {
        this._loading = value;
    }

    set searchFields (fields: Array<any>){
        this._searchFields = fields;
    }

    get searchFields(): Array<any> {
        return this._searchFields;
    }

    setTableFilterData = (fields: Array<any>) => {
        this._searchFields = fields;
    }

    getSearchFields = () => {
        return this.searchFields;
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => { }

    get paginatorRequestParams() {
        if (this.orderFieldName) {
            return {
                current: this.current,
                pageSize: this.pageSize,
                orderFieldName: this.orderFieldName,
                orderDirection: this.orderDirection === 'ascend' ? 'asc' : 'desc',
            }
        }

        return { current: this.current, pageSize: this.pageSize }
    }

    get accessCheckRequestParams(){
        return this.actions.map(action => HelperService.generateURL(this.module, action))
    }
}